var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    clipPath: "url(#clip0_4142_7282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.92857 17.1111C4.92857 18.15 5.76429 19 6.78571 19H14.2143C15.2357 19 16.0714 18.15 16.0714 17.1111V5.77778H4.92857V17.1111ZM6.78571 7.66667H14.2143V17.1111H6.78571V7.66667ZM13.75 2.94444L12.8214 2H8.17857L7.25 2.94444H4V4.83333H17V2.94444H13.75Z",
    fill: "#D7D7D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4142_7282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOff);
export default __webpack_public_path__ + "static/media/deleteOff.120bc8ba3601e04fcb36491591157e51.svg";
export { ForwardRef as ReactComponent };